module.exports = __webpack_public_path__ + "img/arrowFillRightOrienIcon.975e2913.svg";